//封面音频
<template>
    <div class="view19Wrapper shadowRadius cardMinHeight">
        <div v-if="isAudioLoading" class="loading">
            <img src="~@/assets/img/loading1.gif" alt="">
        </div>
        <div class="playerWrapper">
            <div>
                <div class="audioInfo">
                    <div class="cover">
                        <img :src="audioList[audioCurrentIndex].cover" alt="频道封面">
                    </div>
                    <div class="content">
                        <my-marquee v-if="audioList[audioCurrentIndex].name.length > 9" :text="audioList[audioCurrentIndex].name" styleType="title"></my-marquee>
                        <div class="name" v-else>{{audioList[audioCurrentIndex].name}}</div>

                        <div class="source">内容来源：{{audioList[audioCurrentIndex].source}}</div>

                        <my-marquee :text="audioList[audioCurrentIndex].desc" styleType="normal"></my-marquee>
                    </div>
                </div>
                <div v-if="!isPC" class="slider" @touchstart="handleTouchStart" ref="track">
                    <div class="slider-track"></div>
                    <div class="slider-fill" :style="'width:'+progress+'%'"></div>
                    <div class="slider-thumb" :style="'left: '+progress+'%'"></div>
                </div>
                <div v-else class="slider" @mousedown="handleMouseDown" ref="pcTrack">
                    <div class="slider-track"></div>
                    <div class="slider-fill" :style="'width:'+progress+'%'"></div>
                    <div class="slider-thumb" :style="'left: '+progress+'%'"></div>
                </div>
                <div class="timeInfo">
                    <div class="currentTime">
                        {{formatTime(displayCurrentTime)}}
                    </div>
                    <div class="duration">
                        {{formatTime(displayDuration)}}
                    </div>
                </div>
                <div class="menu">
                    <div class="last" @click="handleLastAudio">
                        <img src="~@/assets/img/lastAudio.png" alt="上一首">
                    </div>
                    <div class="play" @click="handlePlay">
                        <div v-if="isPlay"><img src="~@/assets/img/pauseAudio.png" alt="暂停"></div>
                        <div v-else><img src="~@/assets/img/playAudio.png" alt="开始"> </div>
                    </div>
                    <div class="next" @click="handleNextAudio">
                        <img src="~@/assets/img/nextAudio.png" alt="下一首">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex"
    import MyMarquee from '@/components/Use/my-marquee'
    import {formatAudioTime, audioDetailTemplate} from '@/utils/utils'

    export default {
        name: "View19",
        props: {
            list: {
                type: Array,
                default: ()=>[]
            },
            tips: {
                type: String,
                default: ""
            }
        },
        data(){
            return {
                progress: 0,
                displayDuration: 0, //封面的返回时长跟浏览器获得音频时长不一样，这里只对数据做展示
                displayCurrentTime: 0, //时长不一样，当前时间也需要做出响应调整
                isPlay: true,
                isShouldLoading: false,
            }
        },
        components: {MyMarquee},
        computed: {
            ...mapState(["isPC", "questionTips", "device"]),
            ...mapState('audio', [ "fPlayer", "audioCurrentIndex", "audioList", "audioCurrentTime", "duration", "isAudioLoading"])
        },
        created() {
            // this.setPause(false)
            this.setAudioBarShow(false)
            this.setAudioLoading(true)
            this.setAudioList(this.list)
            this.fPlayer.addEventListener('timeupdate', this.timeUpdate)
            this.fPlayer.addEventListener('ended', this.timeEnded)
            this.fPlayer.addEventListener("canplay",this.init, false)
            if(this.questionTips !== '音频详情'){
                this.setAudioCurrentIndex(-1)
                this.setAudioCurrentTime(0)
                this.setDuration(0)
            }
            if(this.audioCurrentIndex === -1){
                this.setAudioCurrentIndex(Math.round(Math.random() * (this.audioList.length - 1)))
            }
            if(this.fPlayer.getAttribute('src') !== this.audioList[this.audioCurrentIndex].url){
                this.fPlayer.setAttribute('src', this.audioList[this.audioCurrentIndex].url)
            }
            this.fPlayer.currentTime = this.audioCurrentTime
            this.getDuration()
            this.fPlayer.play()
        },
        beforeDestroy() {
            this.fPlayer.removeEventListener('timeupdate', this.timeUpdate)
            this.fPlayer.removeEventListener('ended', this.timeEnded)
            this.fPlayer.pause()
            this.setPause(true)
            this.setAudioLoading(false)
        },
        methods: {
            ...mapMutations('audio', ["setAudioCurrentIndex", "setAudioCurrentTime", "setAudioList", "setDuration", "setAudioLoading", "setPause"]),
            ...mapMutations(["contactDisData", "setChatLoading", "setAudioBarShow"]),
            init(){
                //监听audio是否加载完毕，如果加载完毕，则读取audio播放时间
                this.isShouldLoading = true
                this.setAudioLoading(false)
                console.log('mp3加载完成............')
                this.getDuration()
                this.fPlayer.currentTime = this.audioCurrentTime
                this.fPlayer.play()
                this.fPlayer.removeEventListener("canplay",this.init, false) //在电脑调试IOS环境下会连续触发，故去掉监听
            },
            getDuration() {
                this.displayDuration = this.formatDisplayDuration(this.audioList[this.audioCurrentIndex].duration)
                // 极个别音频获取不到时长
                if(this.fPlayer.duration){
                    this.setDuration(this.fPlayer.duration)
                } else {
                    this.setDuration(this.formatDisplayDuration(this.audioList[this.audioCurrentIndex].duration))
                }
            },
            formatDisplayDuration(duration){
                const [minute, second='0'] = duration.split('.')
                let time = Number(minute) * 60 + Number(second)
                return time
            },
            timeUpdate(e){
                if(this.isAudioLoading){
                    this.setAudioLoading(false)
                }
                this.setAudioCurrentTime(e.target.currentTime)
                if(this.duration != 0){
                    this.progress = this.audioCurrentTime <= this.duration ? this.audioCurrentTime / this.duration * 100 : 100
                } else {
                    this.progress = 0
                }
                this.displayCurrentTime = this.progress * this.displayDuration / 100
            },
            timeEnded(){
                this.handleNextAudio()
            },
            handleLastAudio(){
                this.debounce(()=>{
                    // 加载超过1s才显示loading
                    this.isShouldLoading = false
                    setTimeout(()=>{
                        if(!this.isShouldLoading){
                            this.setAudioLoading(true)
                        }
                    }, 1000)
                    this.progress = 0
                    this.displayCurrentTime = 0
                    this.setAudioCurrentTime(0)
                    const length = this.audioList.length
                    this.setAudioCurrentIndex((this.audioCurrentIndex - 1 + length) % length)
                    this.progress = 0
                    this.setAudioCurrentTime(0)
                    this.displayCurrentTime = 0
                    this.fPlayer.setAttribute('src', this.audioList[this.audioCurrentIndex].url)
                    this.fPlayer.addEventListener("canplay",this.init, false)
                    this.isPlay = true
                    this.fPlayer.play()
                    this.handleDetail()
                }, 500)
            },
            handlePlay(){
                this.isPlay = !this.isPlay
                this.isPlay ? this.fPlayer.play() : this.fPlayer.pause()
            },
            handleNextAudio(){
                this.debounce(()=>{
                    // 加载超过1s才显示loading
                    this.isShouldLoading = false
                    setTimeout(()=>{
                        if(!this.isShouldLoading){
                            this.setAudioLoading(true)
                        }
                    }, 1000)
                    const length = this.audioList.length
                    this.setAudioCurrentIndex((this.audioCurrentIndex + 1) % length)
                    this.progress = 0
                    this.setAudioCurrentTime(0)
                    this.displayCurrentTime = 0
                    this.fPlayer.setAttribute('src', this.audioList[this.audioCurrentIndex].url)
                    this.fPlayer.addEventListener("canplay",this.init, false)
                    // this.getDuration()
                    this.isPlay = true
                    this.fPlayer.play()
                    this.handleDetail()
                }, 500)
            },
            handleMouseDown(e){
                this.fPlayer.play()
                this.isPlay = true
                document.addEventListener("mousemove", this.handleMouseMove)
                document.addEventListener("mouseup", this.handleMouseEnd)
            },
            handleMouseMove(e){
                this.fPlayer.pause()
                this.setPcMoveValue(e)
            },
            handleMouseEnd(e){
                this.isPlay = true
                this.fPlayer.play()
                this.setPcValue(e)
                document.removeEventListener("mousemove", this.handleMouseMove)
                document.removeEventListener("mouseup", this.handleMouseEnd)
            },
            handleTouchStart(e){
                this.fPlayer.play()
                this.isPlay = true
                document.addEventListener("touchmove", this.handleTouchMove)
                document.addEventListener("touchup", this.handleTouchEnd)
                document.addEventListener("touchend", this.handleTouchEnd)
                document.addEventListener("touchcancel", this.handleTouchEnd)
            },
            handleTouchMove(e) {
                this.fPlayer.pause()
                this.setMoveValue(e.changedTouches[0])
            },
            handleTouchEnd(e) {
                this.isPlay = true
                this.fPlayer.play()
                this.setValue(e.changedTouches[0])
                document.removeEventListener("touchmove", this.handleTouchMove)
                document.removeEventListener("touchup", this.handleTouchEnd)
                document.removeEventListener("touchend", this.handleTouchEnd)
                document.removeEventListener("touchcancel", this.handleTouchEnd)
            },
            setValue(e) {
                let currentTime = ((e.clientX - this.$refs.track.getBoundingClientRect().left) / this.$refs.track.clientWidth) * this.duration
                this.setAudioCurrentTime(currentTime)
                this.fPlayer.currentTime = this.audioCurrentTime
                this.displayCurrentTime = this.progress * this.displayDuration / 100
            },
            setMoveValue(e) {
                let progress = ((e.clientX - this.$refs.track.getBoundingClientRect().left) / this.$refs.track.clientWidth) * 100
                this.progress = progress > 100 ? 100 : (progress < 0 ? 0 : progress)
                this.setAudioCurrentTime(this.progress * this.duration / 100)
                this.displayCurrentTime = this.progress * this.displayDuration / 100
            },
            setPcValue(e) {
                let currentTime = (e.clientX - this.$refs.pcTrack.getBoundingClientRect().left) / this.$refs.pcTrack.clientWidth * this.duration
                this.setAudioCurrentTime(currentTime)
                this.fPlayer.currentTime = this.audioCurrentTime
                this.displayCurrentTime = this.progress * this.displayDuration
            },
            setPcMoveValue(e) {
                let progress = ((e.clientX - this.$refs.pcTrack.getBoundingClientRect().left) / this.$refs.pcTrack.clientWidth) * 100
                this.progress = progress > 100 ? 100 : (progress < 0 ? 0 : progress)
                this.setAudioCurrentTime(this.progress * this.duration / 100)
                this.displayCurrentTime = this.progress * this.displayDuration / 100
            },
            formatTime(time) {
                return formatAudioTime(time)
            },
            handleDetail(){
                if(this.questionTips === '音频详情'){
                    this.isPlay = true
                    let audioTemplate = audioDetailTemplate(this.audioList, this.audioList[this.audioCurrentIndex].name)
                    this.contactDisData([{content: {right: true, tips: "音频详情"}}])
                    this.contactDisData(audioTemplate)
                }
            },
            debounce(fn, wait) {
                if (this.timeout !== null) {
                    clearTimeout(this.timeout)
                }
                this.timeout = setTimeout(fn, wait)
            },
        }
    }
</script>

<style lang="less" scoped>
    .view19Wrapper{
        width: 8.72rem;
        height: 6.03rem;
        padding: .67rem .59rem;
        box-sizing: border-box;
        background-color: white;
        position: relative;
        .loading{
            position: absolute;
            width: 8.72rem;
            height: 6.03rem;
            background-color: #fff;
            z-index: 100;
            left: 0rem;
            top: 0;
            border-radius: .2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                width: auto;
                height: 2rem;
            }
        }
        .playerWrapper{
            .audioInfo{
                padding-left: .08rem;
                display: flex;
                justify-content: flex-start;
                .cover{
                    width: 1.65rem;
                    height: 1.65rem;
                    border-radius: 0.13rem;
                }
                .content{
                    display: flex;
                    flex: 1;
                    flex-direction: column;
                    justify-content: space-between;
                    margin: 0 0.27rem;
                    .name {
                        font-size: 0.43rem;
                        font-weight: 600;
                        line-height: 0.43rem;
                        font-family: PingFangSC-Medium, PingFang SC;
                        margin-bottom: .16rem;
                    }
                    .name-content{
                        height: 0.43rem;
                        margin-bottom: .16rem;
                        overflow: hidden;
                        font-size: 0.43rem;
                        font-weight: 600;
                        line-height: 0.43rem;
                        position: relative;
                        font-family: PingFangSC-Medium, PingFang SC;
                        .name-box{
                            height: 0.43rem;
                            position: absolute;
                            .name1{
                                /*animation: name1 10s linear infinite;*/
                                white-space: nowrap;
                                display: inline-block;
                                /*position: absolute;*/
                                padding: 0 .2rem;
                            }
                            .name2{
                                /*animation: name2 10s linear infinite;*/
                                white-space: nowrap;
                                padding: 0 .2rem;
                                position: absolute;
                                display: inline-block;
                            }
                            @keyframes name1 {
                                0% { margin-left: 0; }
                                100% { margin-left: -100%;}
                            }

                            @keyframes name2 {
                                0% { margin-left: 110%; }
                                100% { margin-left: 0; }
                            }
                        }
                    }
                    .source{
                        font-size: 0.32rem;
                        font-weight: 400;
                        color: #999999;
                        line-height: 0.32rem;
                        margin-bottom: .43rem;
                    }
                    .desc-box{
                        width: 4rem;
                        height: .32rem;
                        font-size: .32rem;
                        line-height: .32rem;
                        color: #333333;
                        overflow: hidden;
                        position: relative;
                        .desc{
                            animation: desc 5s linear infinite;
                            white-space: nowrap;
                            position: absolute;
                            padding: 0 .2rem;
                        }
                        .desc2{
                            animation: desc2 5s linear infinite;
                            white-space: nowrap;
                            padding: 0 .2rem;
                            position: absolute;
                        }
                        @keyframes desc {
                            0% { left: 0; }
                            100% { left: -250%;}
                        }

                        @keyframes desc2 {
                            0% { left: 250%; }
                            100% { left: 0; }
                        }
                    }
                }

            }
            .slider{
                width: 7.55rem;
                position: relative;
                height: 0.1rem;
                display: flex;
                padding: 0.45rem 0 0.19rem 0;
                align-items: center;
                cursor: default;
                border-radius: 0.3rem;
                user-select: none;
                outline: none;
                .slider-track {
                    position: absolute;
                    height: 0.05rem;
                    left: 0;
                    right: 0;
                    border-radius: 0.3rem;
                    top: .45rem;
                    background-color: #DFE8FD;
                }

                .slider-fill {
                    position: absolute;
                    height: 0.1rem;
                    width: 100%;
                    background-color: #376DF6;
                    left: 0;
                    border-radius: 0.3rem;
                    top: .45rem;
                    margin-top: -1px;
                }

                .slider-thumb {
                    position: absolute;
                    width: 0.21rem;
                    top: 0.48rem;
                    height: 0.21rem;
                    background-color: #376DF6;
                    color: #ffbb38;
                    border-radius: 50%;
                    transform: translate(-50%, -50%);
                    cursor: pointer;

                }
            }
            .timeInfo{
                display: flex;
                justify-content: space-between;
                height: 0.32rem;
                font-size: 0.32rem;
                font-weight: 400;
                color: #666666;
                line-height: 0.32rem;
            }
            .menu{
                margin: 0.58rem 0 0.72rem 0;
                height: 1rem;
                display: flex;
                justify-content: space-around;
                align-items: center;
                .last, .next{
                    width: .43rem;
                    height: .43rem;
                    display: flex;
                    justify-content: center;
                }
                .play{
                    width: 1.01rem;
                    height: 1.01rem;
                }
            }
        }
    }
</style>
